import { render, staticRenderFns } from "./OtherNews.vue?vue&type=template&id=40631ad6&scoped=true&"
import script from "./OtherNews.vue?vue&type=script&lang=js&"
export * from "./OtherNews.vue?vue&type=script&lang=js&"
import style0 from "./OtherNews.vue?vue&type=style&index=0&id=40631ad6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40631ad6",
  null
  
)

export default component.exports